import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import LoginForm from "./login-form";

const useStyles = makeStyles({
  loginBox: {
    padding: "100px 50px 30px",
    color: "#fff",
    textAlign: "center",
    position: "relative",
    zIndex: "1",
    "&::before": {
      position: "absolute",
      content: '""',
      top: 0,
      right: 0,
      width: "100%",
      height: "80%",
      backgroundColor: "#2530B8",
      borderRadius: "0 0 80px 80px",
      zIndex: "-1",
    },
  },
});

export default function Login({ setToken }) {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.loginBox}>
        <img
          src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
          alt="kiamia-shop"
        />
        <Typography variant="h3" mt={3}>
          برای ورود اطلاعات زیر را کامل کنید
        </Typography>
        <LoginForm setToken={setToken} />
      </Box>
      <Box pb={6}>
        <Typography variant="h3" mb={2} align="center">
          اگر ثبت نام نکرده اید با واحد پشتیبانی ما تماس بگیرید.
        </Typography>
        <Typography variant="h3" mb={1} align="center">
          <a href="tel:02122334455">021-22334455</a>
        </Typography>
      </Box>
    </>
  );
}
